module.exports = __webpack_public_path__ + "images/help/video-preview-todos-819975ed1a3be56f2c35d89ede91e3b4.jpg";